import { JSX } from 'react'

import { IconProps } from '../../icon'

const ActivityClosed: (props: IconProps) => JSX.Element = ({
  dataTestId,
  height,
  id,
  stroke,
  title,
  width,
}: IconProps) => (
  <svg
    data-testid={dataTestId}
    fill='none'
    height={height || 48}
    id={id}
    stroke={stroke}
    viewBox='0 0 48 48'
    width={width || 48}
    xmlns='http://www.w3.org/2000/svg'
  >
    <title>{title}</title>
    <path
      d='M14.1538 8H10.8718C9.29641 8 8 9.29641 8 10.8718V14.1538C8 15.7292 9.29641 17.0256 10.8718 17.0256H14.1538C15.7292 17.0256 17.0256 15.7292 17.0256 14.1538V10.8718C17.0256 9.29641 15.7292 8 14.1538 8ZM14.5641 14.1538C14.5641 14.3836 14.3836 14.5641 14.1538 14.5641H10.8718C10.6421 14.5641 10.4615 14.3836 10.4615 14.1538V10.8718C10.4615 10.6421 10.6421 10.4615 10.8718 10.4615H14.1538C14.3836 10.4615 14.5641 10.6421 14.5641 10.8718V14.1538Z'
      fill='black'
    />
    <path
      d='M14.1538 19.4872H10.8718C9.29641 19.4872 8 20.7836 8 22.359V25.641C8 27.2164 9.29641 28.5128 10.8718 28.5128H14.1538C15.7292 28.5128 17.0256 27.2164 17.0256 25.641V22.359C17.0256 20.7836 15.7292 19.4872 14.1538 19.4872ZM14.5641 25.641C14.5641 25.8708 14.3836 26.0513 14.1538 26.0513H10.8718C10.6421 26.0513 10.4615 25.8708 10.4615 25.641V22.359C10.4615 22.1292 10.6421 21.9487 10.8718 21.9487H14.1538C14.3836 21.9487 14.5641 22.1292 14.5641 22.359V25.641Z'
      fill='black'
    />
    <path
      d='M14.1538 30.9744H10.8718C9.29641 30.9744 8 32.2708 8 33.8462V37.1282C8 38.7036 9.29641 40 10.8718 40H14.1538C15.7292 40 17.0256 38.7036 17.0256 37.1282V33.8462C17.0256 32.2708 15.7292 30.9744 14.1538 30.9744ZM14.5641 37.1282C14.5641 37.358 14.3836 37.5385 14.1538 37.5385H10.8718C10.6421 37.5385 10.4615 37.358 10.4615 37.1282V33.8462C10.4615 33.6164 10.6421 33.4359 10.8718 33.4359H14.1538C14.3836 33.4359 14.5641 33.6164 14.5641 33.8462V37.1282Z'
      fill='black'
    />
    <path
      d='M20.718 13.7436H38.7692C39.4421 13.7436 40 13.1856 40 12.5128C40 11.84 39.4421 11.2821 38.7692 11.2821H20.718C20.0451 11.2821 19.4872 11.84 19.4872 12.5128C19.4872 13.1856 20.0451 13.7436 20.718 13.7436Z'
      fill='black'
    />
    <path
      d='M38.7692 22.7692H20.718C20.0451 22.7692 19.4872 23.3272 19.4872 24C19.4872 24.6728 20.0451 25.2308 20.718 25.2308H38.7692C39.4421 25.2308 40 24.6728 40 24C40 23.3272 39.4421 22.7692 38.7692 22.7692Z'
      fill='black'
    />
    <path
      d='M38.7692 34.2564H20.718C20.0451 34.2564 19.4872 34.8144 19.4872 35.4872C19.4872 36.16 20.0451 36.7179 20.718 36.7179H38.7692C39.4421 36.7179 40 36.16 40 35.4872C40 34.8144 39.4421 34.2564 38.7692 34.2564Z'
      fill='black'
    />
  </svg>
)

export default ActivityClosed
